export const brandName = "Obsession Unisex Salon & Nail Studio";

export const phoneNumber = +918000805599;

export const email = "obsession.saloon@gmail.com";

export const address1 =
  "Plot No. 588, BD Reddy Bhavan, Teachers Colony Phase I, BD Reddy Gardens Road, BN Reddy Nagar Hyderabad, Telangana 500070 India";

export const address1Link = "https://maps.app.goo.gl/wbApQgp1NHMkKZYY9";

export const brandUrl = "https://obsessionsaloon.com/";

export const brandLogo =
  "https://res.cloudinary.com/daelyy9vj/image/upload/v1745477983/obsession-logo_fx880o.jpg";
